// Admin routes
import AdminIndex from "./views/admin/Index.js";
import UserListing from "./views/admin/users/Index";
import CreateUser from "./views/admin/users/CreateUser";
import User from "./views/admin/users/User";
import SurveyDetails from "./views/admin/users/SurveyDetails";
import ReportListing from "./views/admin/reports/Index";
import Completions from "./views/admin/reports/Completions";
import Likerts from "./views/admin/reports/Likerts.js";
import Responses from "./views/admin/reports/Responses.js";
import UserIndex from "./views/user/Index.js";
import SurveyListing from "./views/user/surveys/Index.js";
import Survey from "./views/user/surveys/Survey.js";
import Errors from "./views/admin/reports/Errors.js";
import DemographicView from "./views/admin/reports/Demographics.js";
import PlatformView from "./views/admin/reports/Platforms.js";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-chart-bar-32 text-primary",
    component: <AdminIndex />,
    layout: "/admin",
    child: false,
    invisible: false,
  },
  {
    path: "/users",
    name: "Users",
    icon: "ni ni-single-02 text-primary",
    component: <UserListing />,
    layout: "/admin",
    child: false,
    invisible: false,
  },
  {
    path: "/users/new",
    name: "Create User",
    icon: "ni ni-fat-add text-primary",
    component: <CreateUser />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "/users/:userId",
    name: "User",
    icon: "ni ni-circle-08 text-primary",
    component: <User />,
    layout: "/admin",
    child: true,
    invisible: true,
  },
  {
    path: "/users/:userId/survey/:surveyId",
    name: "Survey",
    icon: "ni ni-circle-08 text-primary",
    component: <SurveyDetails />,
    layout: "/admin",
    child: true,
    invisible: true,
  },
  {
    path: "/reports",
    name: "Reports",
    icon: "ni ni-single-copy-04 text-primary",
    component: <ReportListing />,
    layout: "/admin",
    child: false,
    invisible: false,
  },
  {
    path: "/reports/demographics",
    name: "Demographics",
    icon: "ni ni-check-bold text-primary",
    component: <DemographicView />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "/reports/platforms",
    name: "Platforms",
    icon: "ni ni-check-bold text-primary",
    component: <PlatformView />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "/reports/completions",
    name: "Completions",
    icon: "ni ni-check-bold text-primary",
    component: <Completions />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "/reports/likerts",
    name: "Likerts by %",
    icon: "ni ni-chart-pie-35 text-primary",
    component: <Likerts />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "/reports/responses",
    name: "Open Responses",
    icon: "ni ni-chat-round text-primary",
    component: <Responses />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "/reports/errors",
    name: "Trouble Log",
    icon: "ni ni-notification-70 text-primary",
    component: <Errors />,
    layout: "/admin",
    child: true,
    invisible: false,
  },
  {
    path: "dashboard",
    name: "Dashboard",
    icon: "ni ni-chart-bar-32 text-primary",
    component: UserIndex,
    layout: "/",
    child: false,
    invisible: false,
  },
  {
    path: "surveys",
    name: "Surveys",
    icon: "ni ni-single-copy-04 text-primary",
    component: SurveyListing,
    layout: "/",
    child: false,
    invisible: false,
  },
  {
    path: "surveys/:surveyId",
    name: "Survey",
    icon: "ni ni-chart-bar-32 text-primary",
    component: Survey,
    layout: "/",
    child: true,
    invisible: true,
  },
];

export default routes;
